import { Button, Icon } from "Components";

type AlertProps = {
    title?: string,
    subtitle: string,
    btnText?: string | null,
    btnClick?: () => void
}

const Alert = ({ title = '', subtitle, btnText = '', btnClick }: AlertProps) => <div className="pm-info-banner">
    <div className="pm-info-row">
        <div className="pm-info-icon">
            <Icon type="campaignInfo" />
        </div>

        <div className="pm-info-group">
            <div className="pm-info-text-group">
                {title && <div className="pm-info-title">
                    <strong>{title}</strong>
                </div>}
                <div className="pm-info-description">
                    {subtitle}</div>
            </div>
            {btnText && <Button shape="round" type="primary" className="ant-sm-btn" onClick={btnClick}>{btnText}</Button>}
        </div>
    </div>

</div>

export default Alert;